export const getBaseURI = (node = document) => new URL(node.baseURI).pathname;
//# sourceMappingURL=getBaseURI.js.map